import { InputAdornment, InputLabel, MenuItem, Select, TextField } from "@material-ui/core";
import CameraAltIcon from "@material-ui/icons/CameraAlt";
import { Api, App } from "app-interfaces";
import React from "react";
import { useTranslation } from "react-i18next";

import { metricConverter, metricUnit, useStateValue } from "../../config/AppContext";
import { ScoreType } from "../../types/StaticTypes";
import { BirthDatePicker } from "../Utilities/DatePicker";
import Icons from "../Utilities/Icons";
import { NoPathParamsRoute } from "./ClientEdit";

export function ClientAddRoute({ history }: NoPathParamsRoute) {
  return <ClientAdd onClientAddedSuccessfully={() => history.goBack()} />;
}

export default function ClientAdd({
  onClientAddedSuccessfully,
}: {
  onClientAddedSuccessfully: () => void;
}) {
  const { t } = useTranslation();
  const { ic_user } = Icons;
  const { Methods, countries, metric } = useStateValue() as {
    Methods: App.Methods;
    countries: App.State["countries"];
    metric: App.State["metric"];
  };

  const [previewProfile, setPreviewProfile] = React.useState(`url(${ic_user})`);
  const [profileImageId, setProfileImageId] = React.useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>, onClientAdded: () => void) => {
    e.preventDefault();
    const formInputs = document.querySelectorAll("input.form-control[required]");
    if ([...formInputs].find((formInput) => formInput.hasAttribute("invalid"))) return;
    let params: Api.Client["params"] = {};

    const formData = new FormData(e.currentTarget);
    formData.forEach((v, k) => {
      if (typeof v !== "object" && k === "weight")
        return Object.assign(params, {
          [k]: metricConverter(parseInt(v), `${ScoreType[4]}O`, metric),
        });
      if (typeof v !== "object" && k === "height")
        return Object.assign(params, {
          [k]: metricConverter(parseInt(v), "heightO", metric),
        });
      if (typeof v === "string") return Object.assign(params, { [k]: v.trim() });
      return Object.assign(params, { [k]: v });
    });

    await Methods.postClients({ ...params, photo_id: profileImageId || null });

    return onClientAdded();
  };
  const handleErrors = (e: React.ChangeEvent<HTMLInputElement>) => {
    const formErrors = e.currentTarget as HTMLSpanElement;
    const inputValue = e.currentTarget.value;
    if (!inputValue || inputValue === "" || inputValue.trim() === "") {
      e.currentTarget.toggleAttribute("invalid", true);
      return (formErrors.innerText = `${e.currentTarget.name.replace("_", " ")} is required.`);
    }
    e.currentTarget.toggleAttribute("invalid", false);
    return (formErrors.innerText = "");
  };

  const handleImageUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const newImage = e.currentTarget.files && e.currentTarget.files[0];
    // const preview: any = document.getElementById('profile-preview');
    // const photo_id: HTMLInputElement | any = document.getElementById(
    //   'photo_id'
    // );
    if (!newImage) return;
    const image = await Methods.updateImage(newImage);
    setProfileImageId(image.id);
    // if (preview && photo_id) {
    // preview.innerText = 'Change profile image';
    // photo_id.value = image.id;
    // preview.append(photo_id);
    return setPreviewProfile(`url(${image.small})`);
    // }
  };
  const triggerImageUpload = () => {
    const file = document.getElementById("file");
    file && file.click();
  };

  return (
    <div id="client-add">
      <input id="file" type="file" style={{ display: "none" }} onChange={handleImageUpload} />
      <form
        onSubmit={(e) => handleSubmit(e, onClientAddedSuccessfully)}
        onReset={(e) => e.preventDefault()}
      >
        <section
          id="profile-preview"
          onClick={triggerImageUpload}
          style={{
            display: "block",
            width: "120px",
            height: "120px",
            margin: "0 auto 35px auto",
            borderRadius: "50%",
            textAlign: "center",
            backgroundImage: previewProfile,
            backgroundColor: "#ffffff",
            backgroundRepeat: "no-repeat",
            backgroundSize: "100%",
            position: "relative",
          }}
        >
          {/* Add a profile image
          <input
            id='photo_id'
            name='photo_id'
            type='text'
            style={{ visibility: 'hidden' }}
          /> */}
          <span
            style={{
              position: "absolute",
              bottom: -15,
              right: 36,
              padding: 10,
              background: "#007bff",
              borderRadius: "100%",
              width: 43,
            }}
          >
            {/* <FaCamera color="white" /> */}
            <CameraAltIcon style={{ color: "white" }} />
          </span>
        </section>
        <section style={{ display: "flex", justifyContent: "space-between" }}>
          <TextField
            InputLabelProps={{
              style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
              shrink: true,
            }}
            onChange={handleErrors}
            label={t("First name")}
            autoFocus={true}
            id="first_name"
            name="first_name"
            type="text"
            required
            title=""
            onInvalid={() => {
              const x = document.getElementById("first_name") as HTMLInputElement;
              x?.setCustomValidity(`${t("First Name cannot be empty.")}`);
            }}
            onInput={() => {
              const x = document.getElementById("first_name") as HTMLInputElement;
              x?.setCustomValidity(``);
            }}
          />

          <TextField
            InputLabelProps={{
              style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
              shrink: true,
            }}
            onChange={handleErrors}
            label={t("Last name")}
            id="last_name"
            name="last_name"
            type="text"
            required
            title=""
            onInvalid={() => {
              const x = document.getElementById("last_name") as HTMLInputElement;
              x?.setCustomValidity(`${t("Last Name cannot be empty.")}`);
            }}
            onInput={() => {
              const x = document.getElementById("last_name") as HTMLInputElement;
              x?.setCustomValidity(``);
            }}
          />
        </section>
        <h5
          className="section-heading"
          style={{
            background: "rgb(229 229 229 / 40%)",
            color: "#007bff",
            marginTop: 20,
            marginBottom: 10,
            textTransform: "none",
            fontSize: 14,
            padding: "10px 21px",
            width: 500,
            marginLeft: -21,
          }}
        >
          {t("About the client")}
        </h5>
        <section>
          <div className="form-group d-flex justify-content-between">
            <div style={{ width: "45%" }}>
              <InputLabel htmlFor="gender" style={{ fontSize: 13, fontWeight: "bold" }}>
                {t("Gender")}
              </InputLabel>
              <Select id="gender" name="gender" defaultValue="MALE" style={{ width: "100%" }}>
                <MenuItem value="MALE">{t("Male")}</MenuItem>
                <MenuItem value="FEMALE">{t("Female")}</MenuItem>
              </Select>
            </div>
            <div style={{ width: "45%" }}>
              <InputLabel htmlFor={t("Birthday")} style={{ fontSize: 13, fontWeight: "bold" }}>
                {t("Birthday")}
              </InputLabel>
              <BirthDatePicker />
            </div>
          </div>
          <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "45%", display: "flex", justifyContent: "space-between" }}>
              <TextField
                label={t("Height")}
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "black" }}>{metricUnit("height", metric)}</span>
                    </InputAdornment>
                  ),
                }}
                type="number"
                id="height"
                name="height"
                style={{ width: "48%" }}
              />
              <TextField
                label={t("Weight")}
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <span style={{ color: "black" }}>
                        {metricUnit(`${ScoreType[4]}`, metric)}
                      </span>
                    </InputAdornment>
                  ),
                }}
                type="number"
                id="weight"
                name="weight"
                style={{ width: "48%" }}
              />
            </div>
            <div style={{ width: "45%" }}>
              <TextField
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                label={t("Occupation")}
                type="text"
                id="occupation"
                name="occupation"
              />
            </div>
          </div>
        </section>
        <h5
          className="section-heading"
          style={{
            background: "rgb(229 229 229 / 40%)",
            color: "#007bff",
            marginTop: 20,
            marginBottom: 20,
            textTransform: "none",
            fontSize: 14,
            padding: "10px 21px",
            width: 500,
            marginLeft: -21,
          }}
        >
          {t("Contact information")}
        </h5>
        <section>
          <div
            className="form-group"
            style={{ width: "100%", display: "flex", justifyContent: "space-between" }}
          >
            <div style={{ width: "45%" }}>
              <TextField
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                style={{ width: "100%" }}
                label={t("Phone")}
                type="text"
                id="phone"
                name="phone"
              />
            </div>
            <div style={{ width: "45%" }}>
              <TextField
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                style={{ width: "100%" }}
                label={t("Email")}
                type="text"
                id="email"
                name="email"
                required
                title=""
                onInvalid={() => {
                  const x = document.getElementById("email") as HTMLInputElement;
                  x?.setCustomValidity(`${t("Email cannot be empty.")}`);
                }}
                onInput={() => {
                  const x = document.getElementById("email") as HTMLInputElement;
                  x?.setCustomValidity(``);
                }}
              />
            </div>
          </div>
          <div className="form-group" style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ width: "45%" }}>
              <InputLabel
                htmlFor="country_code"
                style={{ fontSize: 13, fontWeight: "bold", marginTop: 0 }}
              >
                {t("Country")}
              </InputLabel>
              <Select
                id="country_code"
                name="country_code"
                defaultValue=" "
                style={{ width: "100%" }}
              >
                <MenuItem value=" ">{t("Select")}</MenuItem>
                {countries ? (
                  countries.map((country, i: number) => (
                    <MenuItem key={i} value={country.code}>
                      {country.name}
                    </MenuItem>
                  ))
                ) : (
                  <></>
                )}
              </Select>
            </div>
            <div style={{ width: "45%" }}>
              {/* <InputLabel
                htmlFor='city'
                style={{ fontSize: 13, fontWeight: 'bold', marginTop: 0 }}
              >
                {t("CITY")}
              </InputLabel> */}
              <TextField
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                style={{ width: "100%" }}
                label={t("City")}
                type="text"
                id="city"
                name="city"
              />
            </div>
          </div>
          <div
            className="form-group"
            style={{ display: "flex", justifyContent: "space-between", width: "100%" }}
          >
            <div style={{ width: "45%" }}>
              <TextField
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                style={{ width: "100%" }}
                label={t("Street")}
                type="text"
                id="street"
                name="street"
              />
            </div>
            <div style={{ width: "45%" }}>
              <TextField
                InputLabelProps={{
                  style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
                  shrink: true,
                }}
                style={{ width: "100%" }}
                label={t("Postal code")}
                type="number"
                id="postal_code"
                name="postal_code"
              />
            </div>
          </div>
          <TextField
            InputLabelProps={{
              style: { margin: "auto", fontWeight: "bold", fontSize: 17 },
              shrink: true,
            }}
            label={t("Notes")}
            id="notes"
            name="notes"
            type="text"
            fullWidth
          />

          <div className="button-group mt-4">
            <button type="submit" className="btn btn-primary" style={{ width: "100%" }}>
              {t("Save")}
            </button>
          </div>
        </section>
      </form>
    </div>
  );
}
